(function ($) {
  "use strict"
  window.$ = window.jQuery = $
  $(function () {
    let PROFILE_FORM = $("form.js-user-profile-form");
    let PROFILE_ADDRESS_INPUT = PROFILE_FORM.find("input[data-entity='profile-address-address']");
    let PROFILE_STREET_INPUT = PROFILE_FORM.find("input[data-entity='profile-address-street']");
    let PROFILE_HOUSE_INPUT = PROFILE_FORM.find("input[data-entity='profile-address-house']");
    let PROFILE_HOUSING_INPUT = PROFILE_FORM.find("input[data-entity='profile-address-housing']");
    let selected = '';

    PROFILE_FORM.find(".js-profile-address-delete").on("click", function () {
      let id = $(this).data("id");
      $.ajax({
        url: "/ajax/delProfile.php",
        data: {
          id: id,
        },
        success: function (res) {
          $(".profile").html(res);
        },
        error: function (res) {
          console.log($(res).find(".message").html());
        },
      })
    });

    PROFILE_FORM.find('input[data-action="update"]').on('click', function (event) {
      event.preventDefault();
      if (PROFILE_FORM.find('.has-error').length === 0) {
        var formData = new FormData(PROFILE_FORM[0]);
        formData.append('apply', '1');
        $.ajax({
          data: formData,
          method: PROFILE_FORM.attr('method'),
          processData: false,
          contentType: false,
          url: PROFILE_FORM.attr('action'),
          success: function (result) {
            $('.personal-profile-detail').html("<div class=\"message\">\n" +
              "            <div class=\"message-text\">\n" +
              "                <div class=\"message-text_head\"></div>\n" +
              "                Адрес успешно сохранен\n" +
              "            </div>\n" +
              "            <a href=\"/personal/\" class=\"btn btn-form btn-form-lg btn-white\">Мой профиль</a>\n" +
              "        </div>");
            setTimeout(function () {
              window.location.href = '/personal/orders/';
            }, 5000);
          }
        });
      }
    });

    $('.js-check-delivery').on('change', function () {
      checkProfileDelivery();
    });


    PROFILE_STREET_INPUT.autocomplete({
      source: "/ajax/autocompleteAddress2.php",
      minLength: 1,
      appendTo: '#address-container',
      focus: function (event, ui) {

      },
      select: function (event, ui) {
        selected = ui.item.value;
        setTimeout(function () {
          checkProfileDelivery();
        }, 50)
      },
      close: function (event, ui) {
      PROFILE_STREET_INPUT.val(selected);
      }
    });

    function checkProfileDelivery() {

      PROFILE_FORM.find('input[type=submit]').addClass('hide');
      var s = PROFILE_STREET_INPUT.val().trim(),
        $house = PROFILE_HOUSE_INPUT,
        $housing = PROFILE_HOUSING_INPUT,
        h = $house.val().trim(),
        housing = $housing.val().trim(),
        houseMatches,
        houseMask = /\D*(\d+[a-zA-Zа-яА-Я]{0,1})(.*)/;

      houseMatches = h.match(houseMask);

      if (!!houseMatches) {
        h = !!houseMatches[1] ? houseMatches[1].trim() : '';
        $house.val(h);

        if (!!houseMatches[2] && houseMatches[2] !== '') {
          housing = houseMatches[2].trim();
          $housing.val(housing);
        }
      }

      let homeGroup = $house.parent('.form-group');
      if (s) {
        if (h) {
          homeGroup.removeClass('has-error');
          homeGroup.find('.error-message').text('');
          var v = s + ", д" + h;
          if (housing) {
            v += ", к" + housing;
          }
          PROFILE_ADDRESS_INPUT.val(v);
          checkProfileAddressDeliveryAvaliable(v);
        } else {
          homeGroup.addClass('has-error');
          homeGroup.find('.error-message').text('Введите номер дома');
        }
      }
    }

    function checkProfileAddressDeliveryAvaliable(address) {
      if (typeof hasCompany !== "undefined" && hasCompany) {
        showDeliveryError(false);
      } else {
        $.ajax({
          url: '/ajax/checkDelivery.php',
          data: {
            url: 'http://hrm.hatimaki.ru/index.php',
            r: "maps/google/check-address-json",
            site_id: 2,
            address: address,
          },
          success: function (data) {
            var res = JSON.parse(data);

            if (res.min_price > 0) {
              showDeliveryError(false);
            } else {
              showDeliveryError(true);
            }
          },
        });
      }
    }

    function showDeliveryError(hasError) {
      if (hasError) {
        PROFILE_FORM.find('input[type=submit]').addClass('hide');
        PROFILE_STREET_INPUT.parent('#address-container').addClass('has-error');
        PROFILE_STREET_INPUT.parent('#address-container').find('.error-message').text('Только самовывоз');
      } else {
        PROFILE_FORM.find('input[type=submit]').removeClass('hide');
        PROFILE_STREET_INPUT.parent('#address-container').removeClass('has-error');
        PROFILE_STREET_INPUT.parent('#address-container').find('.error-message').text('');
      }
    }

    $(document).find(".x-user-company").submit(function (e) {
      e.preventDefault();
      let $form = $(this);
      let companyPromoCodeErrorBlock = $form.find('.error-message');
      $.ajax({
        url: '/ajax/userCompany.php',
        dataType: "json",
        type: "POST",
        data: $form.serialize(),
        success: function (response) {
          if (response.success === true) {
            location.reload();
          } else {
            companyPromoCodeErrorBlock.text(response.msg);
            companyPromoCodeErrorBlock.removeClass('hide');
          }
        }
      });
    });

    $(document).find('[data-entity="popup-reorder-wrap"]').on('submit', function (e) {
      e.preventDefault();
      let formData = new FormData($(this)[0]);
      $.ajax({
        url: "/ajax/profileActions.php",
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
          let res = JSON.parse(response);
          if (res.success) {
            window.location.href = '/personal/cart/';
          }
        },
        error: function (response) {
          let res = JSON.parse(response);
          console.log(res);
        },
      });


    });


    $(document).find(".x-cheap__bonusbtn").on("click", function () {
      $.ajax({
        url: "/ajax/userCompanyHideBlockCode.php",
        type: "POST",
        success: function () {
          $(document).find(".x-cheap__item_promo").remove();
        },
        error: function () {
        },
      })
    });


    $(document).on('click', '.x-address-delete-modal', function (e) {
      e.preventDefault();
      e.stopPropagation();

      let $modalDeleteAddress = $(document).find('#deleteAddressModal');
      if ($modalDeleteAddress.length) {
        $modalDeleteAddress.find('.x-address-delete').attr('data-urldelete', $(this).data('urldelete'))
        $modalDeleteAddress.foundation('open');
      }
    });

    $(document).on('click', '.x-address-delete', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if ($(this).data('urldelete')) {
        $.ajax({
          url: $(this).attr('data-urldelete'),
          type: "POST",
          success: function () {
            $.ajax({
              method: 'GET',
              url: '/ajax/listAddress.php',
              cache: false,
              dataType: 'html',
              success: function (data) {
                if (data) {
                  $(document).find('.x-box-list-address').html(data);
                  $(document).find('#deleteAddressModal').foundation('close');
                }
              }
            });
          },
          error: function () {
          },
        })
      }
    });


    $(document).on('click', '.x-add-deposit-prepay-modal', function (e) {
      e.preventDefault();
      e.stopPropagation();

      let $modal = $(document).find('#addDepositPrePayModal');
      if ($modal.length) {
        $modal.foundation('open');
      }
    });

    $(document).find('.x-add-deposit-prepay-input').bind('change keyup input click', function () {
      if (this.value.match(/[^0-9]/g)) {
        this.value = this.value.replace(/[^0-9]/g, '');
      }
    });

    $(document).on('click', '.x-add-deposit-prepay', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let $button = $(this);
      let $modal = $(document).find('#addDepositPrePayModal');
      if ($modal.length) {
        let sum = $modal.find('.x-add-deposit-prepay-input').val();
        if (sum) {
          $.ajax({
            url: '/ajax/createPdf.php',
            type: "POST",
            data: {
              sum: sum,
            },
            success: function (data) {
              let $modal = $(document).find('#addDepositPrePayModal');
              if ($modal.length) {
                //$modal.find('.x-add-deposit-prepay-input').addClass('hide');
                $button.addClass('hide');
                $(document).find('.x-add-deposit-prepay-link').attr('href', data);
                $(document).find('.x-add-deposit-prepay-link').removeClass('hide');
                //$modal.foundation('close');
                //window.open(data, '_blank');
              }
            },
            error: function () {
            },
          })
        }
      }
    });

  })
})(jQuery)
